import { ApiUtility } from "./ApiUtility";

class BooksService {
  route = "/posts";
  bookRoute = "/api/books?lang=";
  categoryRoute = "/api/settings/filters?lang=";
  authorRoute = "/api/authors/slug-";
  languagebyid = "/api/languages/";
  categoriesWithBook = "/api/Books/CategoriesWithBook";
  bookdetailRoute = "/api/books/";
  faviroute = "/api/books/";

  getFilters = (productFor: string, authorId?: string) => {
    let url =
      this.categoryRoute +
      localStorage.getItem("lan") +
      "&productFor=" +
      productFor;
    if (authorId) {
      url += "&authorId=" + authorId;
    }
    return ApiUtility.get(url);
  };

  GetLanguageDataById(id: string) {
    return ApiUtility.get(
      this.languagebyid + id + "?lang=" + localStorage.getItem("lan")
    );
  }

  GetCategoryDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    const url = `/api/Books/Categories/${identifier}?lang=` + localStorage.getItem("lan");
    console.log("[BooksService] GetCategoryDataById - Input:", idOrSlug, "IsMongoId:", isMongoId, "Identifier:", identifier, "URL:", url);
    return ApiUtility.get(url);
  }

  GetAuthorDataById(idOrSlug: string) {
    const isMongoId = /^[0-9a-fA-F]{24}$/.test(idOrSlug);
    const identifier = isMongoId ? idOrSlug : `slug-${idOrSlug}`;
    return ApiUtility.get(
      `/api/Books/Authors/${identifier}?lang=` + localStorage.getItem("lan")
    );
  }

  getepubstream(bookId: string, headerWithAuth: any) {
    return ApiUtility.get(
      "api/Books/" + bookId + "/epubstream/" + bookId + ".epub",
      //this.domainname + "/api/books/" + bookId + "/epub/",
      { headers: headerWithAuth }
    );
  }
  getCategoriesWithBook(lang?: string, start?: number, length?: number, bookCount?: number, sort?: string) {
    let url = `${this.categoriesWithBook}?`;

    // Use localStorage.getItem("lan") as default if lang is not provided
    url += `lang=${lang || localStorage.getItem("lan")}`;

    if (start !== undefined) {
      url += `&start=${start}`;
    }
    if (length !== undefined) {
      url += `&length=${length}`;
    }
    if (bookCount !== undefined) {
      url += `&bookCount=${bookCount}`;
    }
    if (sort !== undefined) {
      url += `&sort=${sort}`;
    }

    return ApiUtility.get(url);
  }
  getBooks = (
    start: number,
    length: number,
    IsChildLiterature: boolean,
    categoryId: string,
    authorId: string,
    search: string,
    sort: string,
    langId: string,
    isSpecial: boolean
  ) => {
    console.log("[BooksService] getBooks called with filters:", {
      categoryId,
      authorId,
      langId,
      sort,
      start,
      length,
      IsChildLiterature,
      isSpecial
    });
    
    const url = this.bookRoute +
      localStorage.getItem("lan") +
      "&start=" +
      start +
      "&length=" +
      length +
      "&IsChildLiterature=" +
      IsChildLiterature +
      "&categoryId=" +
      (categoryId ? categoryId : "") +
      "&authorId=" +
      (authorId ? authorId : "") +
      "&search=" +
      (search ? search : "") +
      "&sort=" +
      sort +
      "&bookLangauge=" +
      (langId ? langId : "") +
      "&isSpecial=" +
      isSpecial;
    
    console.log("[BooksService] getBooks URL:", url);
    return ApiUtility.get(url);
  };

  // Book page body: name, author, cover, description, favourite (not SEO meta)
  getBookDetail = (id: string) => {
    const lang = this.getLangParam();
    return ApiUtility.get(`${this.bookdetailRoute}${id}?lang=${lang}`);
  };

  // Helmet/OG only: pageTitle, pageDescription, og*, altText
  getBookSeo = (id: string) => {
    const lang = this.getLangParam();
    return ApiUtility.get(`${this.bookdetailRoute}${id}/SEO?lang=${lang}`);
  };

  getRelatedBooks = (id: string, authorId: string) => {
    debugger;
    return ApiUtility.get(
      this.bookdetailRoute +
      id +
      "/related?lang=" +
      localStorage.getItem("lan") +
      "&authorId=" +
      authorId
    );
  };

  addFavourite = (id: string) => ApiUtility.post(`/api/Books/${id}/favourite`, {});

  removeFavourite = (id: string) => ApiUtility.delete(`/api/Books/${id}/favourite`);

  // Fetch navigation details (TOC + lastPosition CFI)
  getNavigationDetails = (bookId: string) => {
    const payload = { bookId };
    return ApiUtility.post(`/api/Books/navigation-details`, payload);
  };

  getMobileCurrentBook = (id: string) => this.getBookDetail(id);

  // API expects hindi/english, not hi/en from localStorage
  private getLangParam(): string {
    const lan = localStorage.getItem("lan") || "hindi";
    return lan === "hi" ? "hindi" : lan === "en" ? "english" : lan;
  }

  languageBaseRoute = "/api/languages";
  categories = "/api/Books/Categories";

  getLanguages = (lang: string, allLanguage: boolean, languageFor: string) => {
    const url = `${this.languageBaseRoute}?lang=${lang}&allLanguage=${allLanguage}&LanguageFor=${languageFor}`;
    return ApiUtility.get(url);
  };

  getCategories = (lang?: string) => {
    let url = this.categories;
    if (lang) {
      url += `?lang=${lang}`;
    }
    return ApiUtility.get(url);
  };

}
export default new BooksService();
